import parse from 'url-parse';
import { addLocale, useLocale, t } from 'ttag';
import { setLocale } from 'yup';
import { isServer } from '../../utils/helpers';
import {
  BASE_ROUTE_PATH,
  DEFAULT_LANGUAGE,
  LANGUAGES,
  LOCALE_DATA,
} from './config';

export function getMatchingLocale(languages) {
  const localeEntries = Object.entries(LANGUAGES);
  for (const preferredLocale of languages) {
    for (const localeEntry of localeEntries) {
      const locale = localeEntry[0].toLowerCase();
      if (locale === preferredLocale.toLowerCase()) {
        return locale;
      }
    }
  }
  return undefined;
}

export function getLocaleFromUrl(url) {
  const parsed = parse(url);
  const urlParts = parsed.pathname.split('/');
  return getMatchingLocale([urlParts[1]]);
}

export function translateUrl(url, locale) {
  // TODO refactoring this function
  const parsed = parse(url);
  const urlParts = parsed.pathname.split('/');

  const currentLocale = getLocaleFromUrl(url);
  const resUrl = currentLocale ? urlParts.slice(2) : urlParts.slice(1);
  return locale === DEFAULT_LANGUAGE
    ? `/${resUrl}${parsed.query}`
    : `/${locale || DEFAULT_LANGUAGE}/${resUrl}${parsed.query}`;
}

export function setRoutePath(path) {
  return `${BASE_ROUTE_PATH}${path}`;
}

export function setupLocale(url) {
  const urlLocale = getLocaleFromUrl(url);
  const locale = urlLocale || DEFAULT_LANGUAGE;

  if (isServer()) {
    process.env.LOCALE = locale;
  } else {
    window.env.LOCALE = locale;
  }
  return isServer()
    ? {
        // server
        LOCALE: process.env.LOCALE,
      }
    : {
        // client
        LOCALE: window.env.LOCALE,
      };
}

export function fetchLocale() {
  const envLocale = isServer() ? process.env.LOCALE : window.env.LOCALE;
  return envLocale || DEFAULT_LANGUAGE;
}

export function initLocale() {
  const lang = fetchLocale();
  if (lang !== DEFAULT_LANGUAGE) {
    const data = LOCALE_DATA[lang];
    addLocale(lang, data);
    useLocale(lang);
  }
}

setLocale({
  mixed: {
    default: t`помилка в полі`,
    required: t`Обовязкове поле`,
    // oneOf: t`має бути одне з наступних значень: "${values}"`,
    // notOneOf: t`має бути одне з наступних значень: "${values}"`,
  },
  string: {
    // length: t`має містити саме ${length} символів`,
    // min: t`має містити принаймні ${min} символів`,
    // max: t`повинно бути не більше ${max} символів`,
    //   matches: t`повинні відповідати`,
    email: t`Не вірніий email`,
    //   url: t`Не вірніий URL`,
    //   uuid: t`Не вірніий UUID`,
    //   trim: t`повинен бути обрізаним рядком`,
    //   lowercase: t`має бути рядком у нижньому регістрі`,
    //   uppercase: t`має бути рядком верхнього регістру`,
  },
  // number: {
  //   min: t`має бути більшим або рівним ${min}`,
  //   max: t`must be less than or equal to ${max}`,
  //   lessThan: t`має бути меншим або рівним ${less}`,
  //   moreThan: t`має бути більше ${more}`,
  //   positive: t`має бути додатним числом`,
  //   negative: t`must be a negative number`,
  //   integer: t`має бути від’ємним числом`,
  // },
  // date: {
  //   min: t`поле має бути пізніше ніж ${min}`,
  //   max: t`Поле має бути раніше ніж ${max}`,
  // },
  // boolean: {
  //   isValue: t`поле має мати ${value}`,
  // },
  array: {
    min: t`Обовязкове поле`,
    //   max: t`поле має мати менше або дорівнює ${max} значень`,
    //   length: t`поле має мати ${length} значень`,
  },
});
